// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import DynamicFormSettingsResourceViewModel from '../../../../viewModel/resource/DynamicFormSettingsResourceViewModel';
import DynamicFormFieldDefinitionResourceViewModel from '../../../../viewModel/resource/DynamicFormFieldDefinitionResourceViewModel';
import DynamicFormDefinitionResourceViewModel from '../../../../viewModel/resource/DynamicFormDefinitionResourceViewModel';
import DynamicFormDefinitionResourceDTO from '../../dto/resource/DynamicFormDefinitionResourceDTO';

export default abstract class DynamicFormDefinitionResourceModel extends BaseModel<DynamicFormDefinitionResourceDTO> {
  /**
  */
  get id() { return this.dto.id; }
  set id(value) { this.dto.id = value; }
  /**
  */
  get caption() { return this.dto.caption; }
  set caption(value) { this.dto.caption = value; }
  /**
  */
  get settings() { return this.getObjectModel(() => this.dto.settings, DynamicFormSettingsResourceViewModel)!; }
  set settings(value) { this.setObjectModel(() => this.dto.settings, value); }
  /**
  */
  get fields() { return this.getArrayModels(() => this.dto.fields, DynamicFormFieldDefinitionResourceViewModel)!; }
  set fields(value) { this.setArrayModels(() => this.dto.fields, value); }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    this.dto.id = qs.id;
    this.dto.caption = qs.caption;
  }
}
